import UserAllocationView from './components/user-allocation-view';

export default UserAllocationView;
